import { FC } from 'react';
import { HStack, Text } from '@bpba/ui-components';

type Props = {
  children?: (string | React.ReactElement)[];
  ariaLabel?: string;
};

export const ResumenBase: FC<Props> = ({ children, ariaLabel }) => {
  return (
    <HStack aria-label={ariaLabel} py={'16px'}>
      <Text paddingX={'5px'}> ✓ </Text>
      <Text>{children}</Text>
    </HStack>
  );
};
